import { z } from 'zod';

export const ContentfulSysSchema = z.looseObject({
  id: z.string(),
  type: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
  locale: z.string().optional().nullable(),
  contentType: z.object({
    sys: z.object({
      id: z.string(),
      linkType: z.literal('ContentType'),
      type: z.literal('Link')
    })
  }),
  revision: z.number().optional().nullable(),
  space: z
    .object({
      sys: z.object({
        type: z.literal('Link'),
        linkType: z.literal('Space'),
        id: z.string()
      })
    })
    .optional()
    .nullable(),
  environment: z
    .object({
      sys: z.object({
        id: z.string(),
        type: z.literal('Link'),
        linkType: z.literal('Environment')
      })
    })
    .optional()
    .nullable()
});
